module.exports = __webpack_public_path__ + "img/logo-3.26db5283.svg";